import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "src/app/injectable/auth/auth.service";
import { DistributionListService } from "src/app/injectable/distribution-list.service";
import { GenericErrorModalService } from "src/app/injectable/generic-error-handling/generic-error-modal.service";
import { MessageService } from "src/app/injectable/message.service";
import { DistributionList } from "src/app/model/distributionList";
import { ErrorResponseList } from "src/app/model/errorResponseList";
import { Lista } from "src/app/model/lista";
import { DialogGenericErrorResponseComponent } from "src/app/shared/components/dialog/dialog-generic-error-response/dialog-generic-error-response.component";
import { DialogComponent } from "src/app/shared/components/dialog/dialog.component";
import { VERSION } from "src/environments/version";
import { DeleteListComponent } from "../delete-list/delete-list.component";
import { EditListComponent } from "../edit-list/edit-list.component";
import { NewListComponent } from "../new-list/new-list.component";
import { MatPaginatorIntlDistList } from "./customPaginatorIntl";

@Component({
  selector: "app-distribution-list",
  templateUrl: "./distribution-list.component.html",
  styleUrls: ["./distribution-list.component.scss"],
})
export class DistributionListComponent implements OnInit, AfterViewInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  version = VERSION.version;
  displayedColumns = [
    "validity",
    "subject",
    "senderName",
    "listUsers",
    "createdDate",
    "modifiedDate",
    "actions",
  ];
  user: string;
  dataSource;
  serverMessage: any = "";
  lists: Lista[];
  emptyList = false;
  loading = false;
  sub = false;

  constructor(
    private distlistService: DistributionListService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private messageService: MessageService,
    private authService: AuthService,
    private genericErrorModalService: GenericErrorModalService
  ) {}

  ngOnInit(): void {
    this.user = sessionStorage.getItem("user");
    this.refresh();
    this.paginator._intl = new MatPaginatorIntlDistList();
  }

  ngAfterViewInit() {
    // this.dataSource.filterPredicate = (data, filter: string) => {
    //   if (data.detailRow) {
    //     return ('' + data.element.subject + '.' + data.element.senderName).toLocaleLowerCase().includes(filter)
    //   }
    //   return ('' + data.subject + '.' + data.senderName).toLocaleLowerCase().includes(filter)
    // };
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case "createdDate": {
          return parseISOString(item.distListDTO.createdDate);
        }
        case "modifiedDate": {
          return parseISOString(item.distListDTO.modifiedDate);
        }
        case "subject": {
          return item.distListDTO.name;
        }
        case "senderName": {
          return item.senderName;
        }
        case "listUsers": {
          return +item.numDev;
        }
        default: {
          return item[property];
        }
      }
    };
  }

  refresh() {
    this.lists = null;
    this.dataSource = new MatTableDataSource<DistributionList>();
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.loading = true;
    this.distlistService.getDistributionLists().subscribe(
      (resp: Lista[]) => {
        if (!resp) {
          return;
        } else {
          // Popola la lista di messaggi
          this.lists = resp;
          if (resp.length > 0) {
            this.emptyList = false;
          } else {
            // Messaggio sbagliato
            this.emptyList = true;
          }
        }
        this.dataSource.data = resp;
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        this.genericErrorModalService.open(
          "Errore nel caricamento delle liste di distribuzione",
          err
        );
      }
    );
  }

  logout() {
    this.authService.token = null;
    this.router.navigate(["/login"], { relativeTo: this.route });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: "400px",
      data: { message: this.serverMessage.message },
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }

  newListDialog(): void {
    const dialogRef = this.dialog.open(NewListComponent, {
      panelClass: "custom-dialog-container",
      width: "400px",
      maxHeight: "80vh",
      data: { message: this.serverMessage.message },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == "created") {
        this.router
          .navigateByUrl("/refreshComponent", { skipLocationChange: true })
          .then(() => {
            this.router.navigate(["/distribution-list"]);
          });
        this.openSuccessSnackBar();
      } else if (result == "error") {
        this.openFailedSnackBar();
      } else if (result === undefined) {
      }
    });
  }
  openSuccessSnackBar() {
    const conf = new MatSnackBarConfig();
    conf.duration = 5000;
    this._snackBar.open("Lista creata con successo.", null, conf);
  }
  openFailedSnackBar() {
    const conf = new MatSnackBarConfig();
    conf.duration = 5000;
    this._snackBar.open("Si è verificato un errore.", null, conf);
  }

  openDeleteListDialog(id: string) {
    const dialogRef = this.dialog.open(DeleteListComponent, {
      width: "400px",
    });

    dialogRef.afterClosed().subscribe((choice) => {
      if (choice == "delete") {
        this.distlistService.deleteDistributionList(id).subscribe(
          (response) => {
            this.sub = false;
            this.router
              .navigateByUrl("/refreshComponent", { skipLocationChange: true })
              .then(() => {
                this.router.navigate(["/distribution-list"]);
              });
            this.openSuccessDeleteSnackBar();
          },
          (err) => {
            this.genericErrorModalService.open(
              "Errore nell'eliminazione della lista",
              err
            );
            let error: ErrorResponseList = new ErrorResponseList();
            error = err.error;
            if (error.errorCode != undefined && error.errorCode != "") {
              this.openErrorDialogSentMessage(
                "Errore nella cancellazione della lista di distribuzione",
                error.errorCode
              );
            } else {
              this.openErrorDialogSentMessage(
                "Errore nella cancellazione della lista di distribuzione",
                "ERR00"
              );
            }
          }
        );
      } else if (choice == "cancel") {
      }
    });
  }

  openErrorDialogSentMessage(msg: string, error: string) {
    const dialogRef = this.dialog.open(DialogGenericErrorResponseComponent, {
      width: "500px",
      height: "220px",
      data: {
        message: msg,
        errorCode: error,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }
  openSuccessDeleteSnackBar() {
    const conf = new MatSnackBarConfig();
    conf.duration = 5000;
    this._snackBar.open("Lista eliminata con successo.", null, conf);
  }

  openEditListDialog(id: string, senderid: string, name: string) {
    const dialogRef = this.dialog.open(EditListComponent, {
      panelClass: "custom-dialog-container",
      width: "400px",
      maxHeight: "80vh",
      data: {
        listId: id,
        senderId: senderid,
        name,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == "modified") {
        this.router
          .navigateByUrl("/refreshComponent", { skipLocationChange: true })
          .then(() => {
            this.router.navigate(["/distribution-list"]);
          });
        this.openSuccessEditSnackBar();
      } else if (result == "error") {
        this.openFailedSnackBar();
      } else if (result === undefined) {
      }
    });
  }
  openSuccessEditSnackBar() {
    const conf = new MatSnackBarConfig();
    conf.duration = 5000;
    this._snackBar.open("Lista modificata con successo.", null, conf);
  }
}

function parseISOString(s) {
  const b = s.split(/\D+/);
  return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]));
}
